import { ChevronsUpDown, LogOut } from "lucide-react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { createAvatar, Result } from "@dicebear/core";
import { initials } from "@dicebear/collection";
import { useEffect, useState } from "react";
import { decodeJwt } from "jose";
import { useAuth } from "@/hooks/use-auth";

export function NavUser() {
  const { token, logout } = useAuth();
  const { isMobile } = useSidebar();
  const [email, setEmail] = useState<string | null>(null);
  const [avatar, setAvatar] = useState<Result | null>(null);

  useEffect(() => {
    if (token) {
      const decodedToken = decodeJwt(token);
      setEmail(
        (decodedToken?.email as string) || (decodedToken?.username as string)
      );
    }
  }, [token]);

  useEffect(() => {
    if (email) {
      const avatar = createAvatar(initials, {
        seed: email,
        size: 32,
        radius: 50,
      });
      setAvatar(avatar);
    }
  }, [email]);

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="h-6 w-6 rounded-lg">
                <AvatarImage
                  src={`data:image/svg+xml;utf8,${encodeURIComponent(
                    avatar?.toString() || ""
                  )}`}
                  alt={email || ""}
                />
                <AvatarFallback className="rounded-lg">CN</AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate text-xs">{email || ""}</span>
              </div>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <Avatar className="h-6 w-6 rounded-lg">
                  <AvatarImage
                    src={`data:image/svg+xml;utf8,${encodeURIComponent(
                      avatar?.toString() || ""
                    )}`}
                    alt={email || ""}
                  />
                  <AvatarFallback className="rounded-lg">CN</AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate text-xs">{email || ""}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={logout}>
              <LogOut />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
